import { create } from 'zustand';
import { UserActivation } from '../components/Activation/types';

/**
 * Zustand store for shared activation state
 *
 * This ensures all components see the same activation state.
 * The useActivation hook wraps this store and provides API methods.
 */
interface ActivationStore {
  // State
  activation: UserActivation | null;
  isLoading: boolean;
  error: Error | null;

  // Actions
  setActivation: (activation: UserActivation | null) => void;
  setIsLoading: (isLoading: boolean) => void;
  setError: (error: Error | null) => void;
  reset: () => void;
}

export const useActivationStore = create<ActivationStore>((set) => ({
  // Initial state
  activation: null,
  isLoading: true,
  error: null,

  // Simple setters - the useActivation hook handles the actual API calls
  setActivation: (activation) => set({ activation }),
  setIsLoading: (isLoading) => set({ isLoading }),
  setError: (error) => set({ error }),
  reset: () => set({ activation: null, isLoading: true, error: null }),
}));
